import { useEffect } from "react";
import { t } from "i18next";
import { Button, Card } from "react-bootstrap";
import useDetailsAction from "@main/producers/actions/details/useDetailsAction";
import GoBack from "@main/panel-components/GoBack";

function ProducerMainTab(props: { producerId: string, formDefaultValues: any}) {
  const { producerId, formDefaultValues } = props;

  const {
    getFunction,
    onSubmitFunction,
    actionTemplate
  } = useDetailsAction(parseInt(producerId), formDefaultValues);

  useEffect(() => {
    if (!producerId ) return;
    getFunction(producerId);
  }, [producerId]);

  if (!producerId) return null;

  return (
    <Card>
      <Card.Header>
        <Card.Title><GoBack/> {t("main_data")}</Card.Title>
      </Card.Header>

      <Card.Body>
        {actionTemplate}
      </Card.Body>

      <Card.Footer>
        <Button variant="primary" onClick={onSubmitFunction}>
          {t('save_changes')}
        </Button>
      </Card.Footer>
    </Card>
  );
}

export default ProducerMainTab;
